import { render, staticRenderFns } from "./RemoveBorrow.vue?vue&type=template&id=d2bfb156&scoped=true&"
import script from "./RemoveBorrow.vue?vue&type=script&lang=js&"
export * from "./RemoveBorrow.vue?vue&type=script&lang=js&"
import style0 from "./RemoveBorrow.vue?vue&type=style&index=0&id=d2bfb156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bfb156",
  null
  
)

export default component.exports